import { useEffect, useRef, useState } from 'react';
import { 
    getCantons, getDistrics, getOccupations, getNeighborhoods, 
    getProvinces, getProfessions, getDocuments, getEducations, getMaritalStatus, getIndustryTypes 
} from '../services';
import { retryAsyncs } from '../utils/retryAsync';

const CACHE_KEY = "catalogsDataAdrees";
const CACHE_KEY_PRIORITY = "catalogsDataPriority";
const SESSION_KEY = "catalogsLoadedSession";

export function useCatalogs() {
    const [catalogs, setCatalogs] = useState(() => {
        const cached = localStorage.getItem(CACHE_KEY);
        const priority = localStorage.getItem(CACHE_KEY_PRIORITY);
        return {
            ...(cached ? JSON.parse(cached) : {}),
            ...(priority ? JSON.parse(priority) : {})
        };
    });

    const [loading, setLoading] = useState({
        critical: true,
        address: true
    });

    const hasLoaded = useRef(false);

    useEffect(() => {
        if (hasLoaded.current) return;
        hasLoaded.current = true;

        if (sessionStorage.getItem(SESSION_KEY)) {
            setLoading({ critical: false, address: false });
            return;
        }
        async function loadCritical() {
            try {
                const [documents, professions, occupations, industryTypes] = await Promise.all([
                    retryAsyncs(() => getDocuments(), 3, 1500),
                    retryAsyncs(() => getProfessions(), 3, 1500),
                    retryAsyncs(() => getOccupations(), 3, 1500),
                    retryAsyncs(() => getIndustryTypes(), 3, 1500),
                ]);
                const data = { documents, professions, occupations, industryTypes };
                setCatalogs(prev => ({ ...prev, ...data }));
                localStorage.setItem(CACHE_KEY_PRIORITY, JSON.stringify(data));
            } catch (error) {
                console.error("Error en catálogos críticos:", error);
            } finally {
                setLoading(prev => ({ ...prev, critical: false }));
            }
        }

        async function loadAddress() {
            try {
                const [educations, maritalStatus, provinces, cantons, district, neighborhoods] = await Promise.all([
                    retryAsyncs(() => getEducations(), 3, 1500),
                    retryAsyncs(() => getMaritalStatus(), 3, 1500),
                    retryAsyncs(() => getProvinces(), 3, 1500),
                    retryAsyncs(() => getCantons(), 3, 1500),
                    retryAsyncs(() => getDistrics(), 3, 1500),
                    retryAsyncs(() => getNeighborhoods(), 3, 1500)
                ]);
                const data = { educations, maritalStatus, provinces, cantons, district, neighborhoods };
                setCatalogs(prev => ({ ...prev, ...data }));
                localStorage.setItem(CACHE_KEY, JSON.stringify(data));
                sessionStorage.setItem(SESSION_KEY, 'true');
            } catch (error) {
                console.error("Error en catálogos de dirección:", error);
            } finally {
                setLoading(prev => ({ ...prev, address: false }));
            }
        }
        loadCritical();
        loadAddress();

    }, []);

    return { catalogs, loading };
}
